import { StandardNode } from '@/nodeComponents/StandardNode';
import { StandardNodeWithComponent } from '@/nodeComponents/StandardNodeWithComponent';
import { FunctionNode } from '@/nodeComponents/FunctionNode';
import { FunctionInputsNode } from '@/nodeComponents/FunctionInputsNode';
import { FunctionOutputsNode } from '@/nodeComponents/FunctionOutputsNode';
import { HttpRequestNode } from '@/nodeComponents/HttpRequestNode';
import { FormTriggerNode } from '@/nodeComponents/FormTriggerNode';
import { ApiServerNode } from '@/nodeComponents/ApiServerNode';
import { UnpackNode } from '@/nodeComponents/UnpackNode';

// Registry mapping node components IDs to their implementations
// This should probably be refactored down the line and be more dynamic
export const NODE_COMPONENTS = {
    standard: StandardNode,
    standardWithComponent: StandardNodeWithComponent,
    function: FunctionNode,
    functionInputs: FunctionInputsNode,
    functionOutputs: FunctionOutputsNode,
    httpRequest: HttpRequestNode,
    formTrigger: FormTriggerNode,
    apiServer: ApiServerNode,
    unpack: UnpackNode,
} as const;

export type NodeComponentId = keyof typeof NODE_COMPONENTS;

export const getNodeComponent = (componentId: NodeComponentId) => {
    return NODE_COMPONENTS[componentId] || null;
};
